import { all } from 'redux-saga/effects';

import { agencySaga } from '../modules/Agency/store/sagas';
import { applyPositionSaga, careersSaga } from '../modules/Careers/store/sagas';
import { configurationsSaga, sendMessageSaga } from '../modules/Contacts/store/sagas';
import { homeSaga } from '../modules/Home/store/sagas';
import { loginSaga } from '../modules/Login/store/sagas';
import { filterSaga, projectSaga, projectsSaga } from '../modules/Projects/store/sagas';

// tslint:disable-next-line:typedef
export default function* rootSaga () {
    yield all([
        agencySaga,
        careersSaga,
        homeSaga,
        loginSaga,
        projectsSaga,
        projectSaga,
        filterSaga,
        configurationsSaga,
        sendMessageSaga,
        applyPositionSaga,
    ]);
}
